import React, { Component } from 'react'
import { ActionDropdown, Sidebar, Input, Modal } from '@driftt/tide'
import CreateNewCategoryContent from 'components/SidebarContent/CreateNewCategoryContent'
import CreateNewSectionContent from 'components/SidebarContent/CreateNewSectionContent'
import ArticleModalContent from 'components/ModalContent/ArticleModalContent'

import { clearCategory, clearSectionToEdit, clearArticle } from 'modules/knowledgebase/actions'
import { searchListing } from 'modules/search/actions'
import { getSearchInput } from 'modules/search/selectors'
import { getCanonicalDomain } from 'modules/settings/selectors'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import HelpCenterLinkIcon from 'images/help_center_link_icon.svg'

import './style.css'

class Header extends Component {
  state = {
    isSidebarOpen: false,
    isCreatingNewCategory: false,
    isCreatingNewSection: false,
    isArticleModalOpen: false
  }

  handleCreateNewArticle = () => {
    this.setState({
      isArticleModalOpen: true
    })
  }

  handleCreateNewCategory = () => {
    this.setState({
      isSidebarOpen: true,
      isCreatingNewCategory: true
    })
  }

  handleCreateNewSection = () => {
    this.setState({
      isSidebarOpen: true,
      isCreatingNewSection: true
    })
  }

  handleCloseSidebar = () => {
    const { actions } = this.props

    this.setState({
      isSidebarOpen: false,
      isCreatingNewCategory: false,
      isCreatingNewSection: false
    })
    actions.clearCategory()
    actions.clearSectionToEdit()
  }

  handleSearch = e => {
    const { actions } = this.props
    actions.searchListing(e.target.value)
  }

  handleCloseArticleModal = () => {
    const { actions } = this.props

    this.setState({
      isArticleModalOpen: false
    }, actions.clearArticle)
  }

  render() {
   const { searchInput, match } = this.props
   const { isArticleModalOpen } = this.state
   return (
     <div className="category-listing-header">
       <h2 className="category-listing-title">Drift Help</h2>
       <div className="category-listing-actions">
         <a
           href={`http://${this.props.canonicalDomain}`}
           className="cname-domain-link"
           target="_blank"
           rel="noopener noreferrer"
         >
           <img className="header-help-center-icon" src={HelpCenterLinkIcon} alt="help center icon"/>
           {`${this.props.canonicalDomain}`}
         </a>
         <div className="category-listing-search">
           <Input
             placeholder="Search articles..."
             type="search"
             value={searchInput}
             autoFocus
             onChange={this.handleSearch}
             className="category-listing-search-input"
           />
         </div>
         <ActionDropdown
           title="Add..."
           buttonType="primary"
           className="category-listing-action-button"
           align="right"
           actions={[
             {
               action: this.handleCreateNewArticle,
               icon: 'article-create-2',
               label: 'New Article'
             },
             {
               action: this.handleCreateNewSection,
               icon: 'section-2',
               label: 'New Section'
             },
             {
               action: this.handleCreateNewCategory,
               icon: 'categories-2',
               label: 'New Category'
             }
           ]}
         />
       </div>

       <Modal
         open={ isArticleModalOpen }
         size="medium"
         onClose={this.handleCloseArticleModal}
       >
         <ArticleModalContent {...this.props} onCloseModal={this.handleCloseArticleModal}/>
       </Modal>

       <Sidebar
         className="category-listing-sidebar"
         isOpen={this.state.isSidebarOpen}
         showClose
         close={this.handleCloseSidebar}
       >
         {this.state.isCreatingNewCategory && <CreateNewCategoryContent onCloseSidebar={this.handleCloseSidebar}/>}
         {this.state.isCreatingNewSection && <CreateNewSectionContent match={match} onCloseSidebar={this.handleCloseSidebar} />}
       </Sidebar>
     </div>
   )
 }
}

const mapStateToProps = state => ({
  canonicalDomain: getCanonicalDomain(state),
  searchInput: getSearchInput(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    searchListing,
    clearCategory,
    clearSectionToEdit,
    clearArticle
  }, dispatch)
})
export default connect(mapStateToProps, mapDispatchToProps)(Header)
